var Kowloon = "كولون";
var HKStates = {
	"Hong Kong Island": "جزيرة هونج كونج",
	Kowloon: Kowloon,
	"Lantau Island": "جزيرة لانتاو",
	"New Territories": "الأقاليم الجديدة"
};

export { Kowloon, HKStates as default };
